"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * User Status for client FE
 * User status OpenAPI
 *
 * The version of the OpenAPI document: 1.7.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionEnum = void 0;
/**
 * action performed on this cluster could be JOIN when  a consumer enter in a cluster, REMOVE when a consumer leave a cluster
 * @export
 * @enum {string}
 */
var ActionEnum;
(function (ActionEnum) {
    ActionEnum["Join"] = "JOIN";
    ActionEnum["Remove"] = "REMOVE";
})(ActionEnum = exports.ActionEnum || (exports.ActionEnum = {}));
